import { quotesConstants } from './constants';
import { quotesAPI } from '../../common/api/quotes';

let requestSequence = 0;

const nextRequestId = () => {
  requestSequence += 1;
  return requestSequence;
};

const errorMessage = error => error.response?.data || error.message;

function getQuotes(page, search, isFilterDisabled, options = {}) {
  const preserveData = options.preserveData === true;
  const requestId = nextRequestId();

  function request() {
    return {
      type: quotesConstants.GET_QUOTES_REQUEST,
      requestId,
      ...(preserveData ? { preserveData: true } : {}),
    };
  }
  function success(data) {
    return { type: quotesConstants.GET_QUOTES_SUCCESS, requestId, data };
  }
  function failure(error) {
    return { type: quotesConstants.GET_QUOTES_FAILURE, requestId, error: errorMessage(error) };
  }

  return dispatch => {
    dispatch(request());

    return quotesAPI.getQuotes(page, search, isFilterDisabled).then(
      ({ quoteRequestSummaries: quotes, meta }) => {
        dispatch(success({ quotes, meta }));
      },
      error => dispatch(failure(error)),
    );
  };
}

function getDashboard(search, isFilterDisabled) {
  const requestId = nextRequestId();

  return dispatch => {
    dispatch({ type: quotesConstants.GET_DASHBOARD_REQUEST, requestId });

    return quotesAPI.getDashboard(search, isFilterDisabled).then(
      data => dispatch({ type: quotesConstants.GET_DASHBOARD_SUCCESS, requestId, data }),
      error =>
        dispatch({
          type: quotesConstants.GET_DASHBOARD_FAILURE,
          requestId,
          error: errorMessage(error),
        }),
    );
  };
}

function updateQuotesComments(quote, folder) {
  return { type: quotesConstants.UPDATE_QUOTES_COMMENTS, quote, folder };
}

export const quotesActions = {
  getQuotes,
  getDashboard,
  updateQuotesComments,
};
